export default "__VITE_ASSET__C05coGwS__"